const u = (id, w = 1600) => `https://images.unsplash.com/photo-${id}?auto=format&fit=crop&w=${w}&q=80`;

export const IMG = {
  hero: u("1600607687939-ce8a6c25118c", 2400),
  reveal: u("1600566753190-17f0baa2a6c3", 2400),
  positioning: u("1618221195710-dd6b41faaea6", 2400),
  privat: u("1616486338812-3dadae4b4ace", 1800),
  business: u("1497366216548-37526070297c", 1800),
  b2b: u("1486406146926-c627a92ad1ab", 2400),
  about: u("1600047509807-ba8f99d2cdde", 2400),
  kontakt: u("1556228453-efd6c1ff04f6", 2000),
  quality: {
    stone: u("1631889993959-41b4e9c6e3c5", 1200),
    glass: u("1600566752355-35792bedcfea", 1200),
    wood: u("1585128792020-803d29415281", 1200),
    kitchen: u("1600121848594-d8644e57abab", 1200),
    bath: u("1615529182904-14819c35db37", 1200),
  },
  cta: u("1567016432779-094069958ea5", 2400),
  leistungen: u("1524758631624-e2822e304c36", 2400),
};

export const NAV = [
  { label: "Leistungen", to: "/leistungen", id: "leistungen" },
  { label: "Privat", to: "/privatreinigung", id: "privat" },
  { label: "Gewerbe", to: "/geschaeftskunden", id: "business" },
  { label: "Über uns", to: "/ueber-uns", id: "about" },
  { label: "Kontakt", to: "/kontakt", id: "kontakt" },
];

const TOP_LEVEL = { privatreinigung: "/privatreinigung", umzugsreinigung: "/umzugsreinigung", baureinigung: "/baureinigung", fensterreinigung: "/fensterreinigung", "gartenbau-pflege": "/gartenbau-pflege" };
export const servicePath = (slug) => TOP_LEVEL[slug] || `/leistungen/${slug}`;

export const PROCESS = [
  { n: "01", t: "Anfrage", d: "Teilen Sie uns Objekt, Umfang und gewünschte Leistung mit." },
  { n: "02", t: "Besichtigung", d: "Falls nötig beurteilen wir das Objekt persönlich." },
  { n: "03", t: "Offerte", d: "Sie erhalten eine klare und nachvollziehbare Offerte." },
  { n: "04", t: "Termin", d: "Wir koordinieren den gewünschten Reinigungstermin." },
  { n: "05", t: "Reinigung", d: "Unser Team führt die vereinbarte Arbeit professionell aus." },
  { n: "06", t: "Qualitätskontrolle", d: "Das Ergebnis wird kontrolliert und sauber übergeben." },
];

export const QUALITY_POINTS = [
  { t: "Sorgfältige Ausführung", d: "Jede Fläche wird so behandelt, wie es das Material verlangt." },
  { t: "Klare Kommunikation", d: "Eine Ansprechperson, kurze Wege, keine offenen Fragen." },
  { t: "Zuverlässige Termine", d: "Vereinbart ist vereinbart. Verschiebungen kündigen wir früh an." },
  { t: "Professionelles Auftreten", d: "Einheitlich, diskret und respektvoll gegenüber Ihrem Zuhause oder Betrieb." },
  { t: "Transparente Offerten", d: "Nachvollziehbare Positionen, keine versteckten Zuschläge." },
  { t: "Individuelle Lösungen", d: "Wir passen den Ablauf dem Objekt an, nicht umgekehrt." },
];

export const TRUST = [
  { t: "Zuverlässigkeit", d: "Feste Termine, gleichbleibendes Team, dokumentierte Leistungen." },
  { t: "Diskretion", d: "Wir arbeiten in privaten Räumen und sensiblen Umgebungen. Entsprechend verhalten wir uns." },
  { t: "Sorgfalt", d: "Materialgerechte Reinigung mit professionellen, schonenden Mitteln." },
  { t: "Qualitätskontrolle", d: "Jeder Einsatz wird geprüft, bevor wir ihn als abgeschlossen betrachten." },
  { t: "Direkte Erreichbarkeit", d: "Sie erreichen uns telefonisch oder per E-Mail. Ohne Warteschleife." },
  { t: "Klare Terminplanung", d: "Sie wissen jederzeit, wann wir kommen und was gemacht wird." },
];

export const WIZARD = {
  objects: ["Wohnung", "Haus", "Büro", "Praxis", "Gewerbe", "Treppenhaus", "Baustelle", "Garten / Aussenanlage", "Andere"],
  cleanings: ["Unterhaltsreinigung", "Umzugsreinigung", "Endreinigung", "Fensterreinigung", "Grundreinigung", "Baureinigung", "Spezialreinigung", "Gartenbau & Pflege"],
  sizes: ["Klein (bis 60 m²)", "Mittel (60–120 m²)", "Gross (120–250 m²)", "Sehr gross (über 250 m²)"],
  rooms: ["1–1.5", "2–2.5", "3–3.5", "4–4.5", "5+", "Nicht relevant"],
  extras: ["Fenster", "Küche", "Backofen", "Kühlschrank", "Badezimmer", "Balkon / Terrasse", "Keller", "Garten", "Andere"],
};

export const MARQUEE = ["Präzision", "Diskretion", "Zuverlässigkeit", "Sorgfalt", "Schweizer Qualität", "Klare Abläufe"];
